import PropTypes from 'prop-types';
import React from 'react';

import {
  calculatePrice, productUrl, productImage, productDescription,
} from '@snapbrains/snapav/src/avantlink';
import SaleTagFull from './parts/sale_tag_full';

export default function Result(props) {
  const { result, settings } = props;
  const {
    avantlinkWebsiteId,
    trackingCode,
    appId,
    buttonText,
  } = settings;
  const calculatedPricing = calculatePrice(result);
  const url = productUrl(
    result,
    avantlinkWebsiteId,
    trackingCode,
    appId,
  );
  const image = productImage(result);
  const target = settings.openNewWindow ? '_blank' : '_self';

  return (
    <div key={`snapgadget_${result.lngProductId}`} className="snapgadget_result">
      <div className="snapgadget_header">
        <a href={url} className="snapgadget_url" target={target} rel="nofollow noreferrer">
          {result.strProductName}
        </a>
        <button type="button" className="snapgadget_close">&#215;</button>
      </div>
      <div className="snapgadget_content">
        <div className="snapgadget_main">
          <div className="snapgadget_image">
            <img src={image} alt={result.strProductName} />
          </div>
          <div className="snapgadget_linked_image">
            <a href={url} className="snapgadget_url" target={target} rel="nofollow noreferrer">
              <img src={image} alt={result.strProductName} />
            </a>
          </div>
        </div>
        <div className="snapgadget_meta">
          <p className="snapgadget_description">
            {productDescription(result)}
            <a href={url} target={target}>View More</a>
          </p>
          <div className="snapgadget-social-controls">
            <button type="button" className="snapgadget-linkFB" data-url={url}>
              Post to Facebook
            </button>
            <button
              type="button"
              className="snapgadget-linkTwitter"
              data-url={url}
              data-title={result.strProductName}
            >
              Post to Twitter
            </button>
            <button
              type="button"
              style={{ display: 'none' }}
              className="snapgadget-linkPinterest"
              data-url={url}
              data-img={image}
              data-title={result.strProductName}
            >
              Post to PInterest
            </button>
          </div>
        </div>
        <SaleTagFull
          settings={settings}
          onSale={calculatedPricing.onSale}
          salePercent={calculatedPricing.salePercent}
          salePrice={result.dblProductSalePrice}
          url={url}
        />
        <div className="snapgadget_view_now">
          <a href={url} className="snapgadget-btn" target={target} rel="nofollow noreferrer">{buttonText || 'View Now'}</a>
        </div>
      </div>
      <div className="snapgadget_footer">
        <div className="snapgadget_merchant">
          <a href={url} target={target} rel="nofollow noreferrer">{result.strMerchantName}</a>
        </div>
        <div className={`snapgadget_price ${calculatedPricing.saleClass}`}>
          <a href={url} target={target} rel="nofollow noreferrer">
            $
            {calculatedPricing.price}
          </a>
        </div>
      </div>
    </div>
  );
}

Result.propTypes = {
  settings: PropTypes.shape({
    appId: PropTypes.number,
    buttonText: PropTypes.string,
    avantlinkWebsiteId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    trackingCode: PropTypes.string,
    openNewWindow: PropTypes.bool,
    darkColor: PropTypes.string,
    borderColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    buttonColor: PropTypes.string,
    lightColor: PropTypes.string,
  }).isRequired,
  result: PropTypes.shape({
    strProductName: PropTypes.string,
    strMerchantName: PropTypes.string,
    lngProductId: PropTypes.string,
    dblProductSalePrice: PropTypes.string,
  }).isRequired,
};
